import React from 'react';
import ReactDOM from 'react-dom/client';
import './roomtile.css';
import Classroom from '../../models/classroom';

import Paper from '@mui/material/Paper';
import { ViewState } from '@devexpress/dx-react-scheduler';
import {
	Scheduler,
	DayView,
	Appointments,
} from '@devexpress/dx-react-scheduler-material-ui';

interface RoomtileProps {
    v: Classroom;
    _toggleSchedules: (id: string) => void;
    _shownSchedules: {};
    _selectedTime: Date;
}

const Appointment = ({children, style, ...restProps}: any) => (
    <Appointments.Appointment
      {...restProps}
      style={{
        ...style,
        backgroundColor: '#820000',
        borderRadius: '8px',
      }}
    >
      {children}
    </Appointments.Appointment>
  );

export default function Roomtile( {v, _toggleSchedules, _shownSchedules, _selectedTime}: RoomtileProps ) {
    return (
        <div className='class' key={v.roomnumber}>
            <div className='class-details'>
                {
                    v.avaliable ?
                        <div className='clas-header'>
                            <h2 className='class-name green'>{v.roomnumber}</h2>
                            <h4> is currently avaliable {v.getUntil()}</h4>
                        </div>
                        :
                        <div className='clas-header'>
                            <h2 className='class-name'>{v.roomnumber}</h2>
                            <h4> is not avaliable {v.getUntil()}</h4>
                        </div>
                }
                <div className='space'></div>
                <a target='blank' href={`https://www.bu.edu/classrooms/classroom/${v.roomnumber.toLowerCase().replace(' ', '-')}/`}>
                    <div className='info'>room info</div>
                </a>
                {
                    <div className='expand' onClick={() => _toggleSchedules(v.roomnumber)}>
                        {
                            _shownSchedules[v.roomnumber as keyof {}] ?
                                'hide schedule' : 'show schedule'
                        }
                    </div>
                }
            </div>
            {
                //if dropdown then show
                _shownSchedules[v.roomnumber as keyof {}] 
                ?
                <div className='scaledown'>
                    <Paper>
                        <Scheduler data={v.getSchedule(_selectedTime)}>

                            <ViewState
                                currentDate={_selectedTime}
                            />

                            <DayView
                                startDayHour={9}
                                endDayHour={22}
                            />

                            <Appointments appointmentComponent={Appointment}/>
                        </Scheduler>
                    </Paper>
                </div>
                :
                ''
            }
        </div>
    )
}